@if (isLargeScreen$()) {
<div class="three-column-container costum-mat-secondary-container">
    @for(elemIds of groupElementSignals['feature-banner'](); let index = $index; track $index) {
    <div class="column">
        <app-base-feature-banner [elementIds]="elemIds"></app-base-feature-banner>
    </div>
    }
</div>
} @else {
    <swiper-container #swiper class="costum-mat-secondary-container" centered-slides="true" autoplay="false" loop="true">
        @for(elemIds of groupElementSignals['feature-banner'](); let index = $index; track $index) {
        <swiper-slide>
            <div class="column">
                <app-base-feature-banner [elementIds]="elemIds"></app-base-feature-banner>
            </div>
        </swiper-slide>

        }
    </swiper-container>
}